import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'listing.title',
  },
  maintainBTN: {
    id: 'listing.maintainBTN',
  },
  medsAtAdmissionBTN: {
    id: 'listing.medsAtAdmissionBTN',
  },
  medsAtAdmissionMSG: {
    id: 'listing.medsAtAdmissionMSG',
  },
  medsVerbalOrderBTN: {
    id: 'listing.medsVerbalOrderBTN',
  },
  medsVerbalOrderMSG: {
    id: 'listing.medsVerbalOrderMSG',
  },
  medsOrdersAndNotesMovedNotice: {
    id: 'listing.medsOrdersAndNotesMovedNotice',
  },
  medsConfDialogTitle: {
    id: 'listing.medsConfDialogTitle',
  },
  continueBTN: {
    id: 'listing.continueBTN',
  },
  medsOpenOrdersandNotesBTN: {
    id: 'listing.medsOpenOrdersandNotesBTN',
  },
  cancelBTN: {
    id: 'listing.cancelBTN',
  },
  okBTN: {
    id: 'listing.okBTN',
  },
  editBTN: {
    id: 'listing.editBTN',
  },
  stopEditBTN: {
    id: 'listing.stopEditBTN',
  },
  updateMedsBTN: {
    id: 'listing.updateMedsBTN',
  },
  medsApprovedPhyBTN: {
    id: 'listing.medsApprovedPhyBTN',
  },
  medsApprovedNonPhyBTN: {
    id: 'listing.medsApprovedNonPhyBTN',
  },
  orderColumnToolTipMsg: {
    id: 'listing.orderColumnToolTipMsg',
  },
  minimumTip: {
    id: 'medication.minimumTip',
  },
  printTip: {
    id: 'medication.printTip',
  },
  needsApproval: {
    id: 'Needs Approval',
  },
  dense: {
    id: 'listing.dense',
  },
  notSetup: {
    id: 'dialog.notSetup',
  },
  finished: {
    id: 'dialog.finished',
  },
  name: {
    id: 'medication.name',
  },
  physician: {
    id: 'medication.physician',
  },
  covered: {
    id: 'medication.covered',
  },
  quantity: {
    id: 'medication.quantity',
  },
  coveredYes: {
    id: 'medication.coveredYes',
  },
  coveredNo: {
    id: 'medication.coveredNo',
  },
  start: {
    id: 'medication.start',
  },
  stop: {
    id: 'medication.stop',
  },
  date: {
    id: 'medication.date',
  },
  approved: {
    id: 'medication.approved',
  },
  sig: {
    id: 'medication.sig',
  },
  physSigLine: {
    id: 'print.physSig',
  },
  physDateLine: {
    id: 'print.physDate',
  },
  physApprovalState: {
    id: 'print.approvalStatement',
  },
  medStatement: {
    id: 'print.medStatement',
  },
  pharmStatement: {
    id: 'print.pharmStatement',
  },
  reconcileAck: {
    id: 'print.reconcileAck',
  },
  verbalCol: {
    id: 'print.verbalCol',
  },
  dateFilter: {
    id: 'medication.dateFilter',
  },
  physFilter: {
    id: 'medication.physFilter',
  },
  recordHardCopy: {
    id: 'medication.recordHardCopy',
  },
  applyFilter: {
    id: 'medication.applyFilter',
  },
  maintainOptionsTxt: {
    id: 'medication.maintainOptionsTxt',
  },
  maintain_opt1: {
    id: 'medication.maintain_opt1',
  },
  maintain_opt2: {
    id: 'medication.maintain_opt2',
  },
  maintain_opt3: {
    id: 'medication.maintain_opt3',
  },
  maintainToRcopiaBtn: {
    id: 'medication.maintainToRcopiaBtn',
  },
  selectDate: {
    id: 'listing.selectDate',
  },
  hardCopySigDateMSG: {
    id: 'listing.hardCopySigDateMSG',
  },
  Submit: {
    id: 'listing.Submit',
  },
  Cancel: {
    id: 'listing.Cancel',
  },
  recordHardCopyMSG: {
    id: 'listing.recordHardCopyMSG',
  },
  recordHardCopyMobileMSG: {
    id: 'listing.recordHardCopyMobileMSG',
  },
  docApprovalConfMSG: {
    id: 'listing.docApprovalConfMSG',
  },
  nurseApprovalConfMSG: {
    id: 'listing.nurseApprovalConfMSG',
  },
  approveMedsDialogTitle: {
    id: 'listing.approveMedsDialogTitle',
  },
  approvalMedLine: {
    id: 'dialog.approvalMedLine',
  },
  ePerscribe: {
    id: 'listing.ePerscribe',
  },
  updateMeds: {
    id: 'listing.updateMeds',
  },
  updateMedsInProgress: {
    id: 'listing.updateMedsInProgress',
  },

  medOrderError: {
    id: 'errors.medOrderError',
  },
  updateMedsAlertSuccess: {
    id: 'alerts.updateMedsSuccess',
  },
  updateMedsAlertError: {
    id: 'alerts.updateMedsError',
  },
});
